<h3 class="modal-title">Rakeback Information</h3>
<p class="modal-description">
  Almost every Bet you make increases your RakeBack. Level up to increase the
  rewards!
</p>
<ul class="tiers--list">
  @for (tier of tiers(); track $index;) {
  <li class="tiers--list__item">
    <div
      class="tier--item box-white-04 hover"
      [class.available]="tier.isAvailable"
      [class.unavailable]="!tier.isAvailable"
    >
      @if (tier.isAvailable) {
      <span class="tier--item__badge typography-small">Current Tier</span>
      }
      <p class="tier--item__title typography-small-title">
        Tier {{ tier.tier }}
      </p>
      <p class="tier--item__level">
        {{ tier.level.from }}@if(tier.level.to) {-{{ tier.level.to }} }@else {+}
        level
      </p>

      <p class="tier--item__chance typography-small">{{ tier.chance }}%</p>
    </div>
  </li>
  }
</ul>
<div class="tiers--notice">
  <p class="typography-small tiers--notice__text">
    Some Wager Abuse rules may apply:
  </p>
  <div class="box-ocean tiers--notice__game rounded-4">Plinko</div>
  <div class="box-red tiers--notice__game rounded-4">Mines</div>
</div>
